import { createRouter, createWebHistory, type Router } from 'vue-router'

import {
  checkIfRedirectToMainView,
  fromEditViewGuard,
  fromMainViewGuard
} from '@/router/helpers.ts'
import {
  ROUTE_ALREADY_HAS_APPOINTMENT,
  ROUTE_APPOINTMENT_CONFIRM,
  ROUTE_APPOINTMENT_FAILURE,
  ROUTE_COOKIES_POLICY,
  ROUTE_EDIT_APPOINTMENT,
  ROUTE_MAIN,
  ROUTE_MODIFY_APPOINTMENT,
  ROUTE_REDIRECT_BRAND
} from '@/router/routeNames.ts'
import AppView from '@/views/AppView/AppView.vue'

export const getRouter = (): Router => {
  return createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
      {
        component: AppView,
        name: ROUTE_MAIN,
        path: '/'
      },
      {
        component: () => import('@/views/AppointmentConfirm/AppointmentConfirm.vue'),
        name: ROUTE_APPOINTMENT_CONFIRM,
        path: '/confirm'
      },
      {
        component: () => import('@/views/AppointmentFailure/AppointmentFailure.vue'),
        name: ROUTE_APPOINTMENT_FAILURE,
        path: '/failure'
      },
      {
        component: () => import('@/views/CookiesPolicy/CookiesPolicy.vue'),
        name: ROUTE_COOKIES_POLICY,
        path: '/cookies-policy'
      },
      {
        beforeEnter: [checkIfRedirectToMainView],
        component: () => import('@/views/SummaryEditView/SummaryEditView.vue'),
        name: ROUTE_EDIT_APPOINTMENT,
        path: '/edit'
      },
      {
        beforeEnter: [fromEditViewGuard],
        component: () => import('@/views/ModifyView/ModifyView.vue'),
        name: ROUTE_MODIFY_APPOINTMENT,
        path: '/edit/modify'
      },
      {
        beforeEnter: [fromMainViewGuard],
        component: () => import('@/views/RedirectBrandView/RedirectBrandView.vue'),
        name: ROUTE_REDIRECT_BRAND,
        path: '/redirect-brand'
      },
      {
        component: () => import('@/views/HasAppointmentView/HasAppointmentView.vue'),
        name: ROUTE_ALREADY_HAS_APPOINTMENT,
        path: '/already-has-appointment'
      },
      {
        path: '/:pathMatch(.*)*',
        redirect: { name: ROUTE_MAIN }
      }
    ]
  })
}
